
// import { adminFileQueryOneByBatchIdAPI } from '@/api/admin/file'

export default {
  // WkSignatureImage
  name: 'WkSignatureImage',

  components: {},

  props: {
    height: {
      type: String,
      default: '100%'
    },
    src: String // batchId 交互
  },

  data: function data() {
    return {
      url: '',
      styleObj: {}
    };
  },


  computed: {
    hasContent: function hasContent() {
      return !!this.url;
    }
  },

  watch: {
    src: function src(newVal, oldVal) {
      if (newVal) {
        this.getData();
      } else {
        this.url = '';
      }
    }
  },

  created: function created() {
    if (this.src) {
      this.getData();
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    getData: function getData() {
      // adminFileQueryOneByBatchIdAPI(this.src).then(res => {
      //   const resData = res.data
      //   if (resData) {
      //     const url = process.env.BASE_API + resData.url
      //     if (this.url !== url) {
      //       this.url = url
      //     }
      //   } else {
      //     this.url = ''
      //   }
      // }).catch(() => {

      // })
      this.url = this.src;
    }
  }
};